import { createFileRoute } from "@tanstack/react-router";
import { MarginScenarioPage } from "../../../../pages/margin-optimization-page/margin-scenario-page";

export const Route = createFileRoute("/_auth/_project/margin-optimization/$projectId/$subProjectId/scenario")({
  component: MarginScenarioPage,
});
